import HeaderResume from './header-resume/index.vue';
import ModalUpdateRd from './modal-update-rd/index.vue';
import TabAccounts from './tab-accounts/index.vue';
import TabAccountsDetails from './tab-accounts-details/index.vue';
import TabDateDetails from './tab-date-details/index.vue';
import TabInvestmentFunds from './tab-investment-funds/index.vue';
import TabKeyProductDetails from './tab-key-product-details/index.vue';
import TabResume from './tab-resume/index.vue';
import UpdateResume from './update-resume/index.vue';

const components = {
    HeaderResume,
    ModalUpdateRd,
    TabAccounts,
    TabAccountsDetails,
    TabDateDetails,
    TabInvestmentFunds,
    TabKeyProductDetails,
    TabResume,
    UpdateResume
};

export default components;
